import { Box } from '@/components/ui/box';
import { Button } from '@/components/ui/button';
import { FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { EditTableViewModal } from '@/pages/TableViews/components/EditTableViewModal';
import { ArrowLeft, Pencil } from 'lucide-react';
import { type FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

interface TableViewHeaderProps {
  title: string;
}

export const TableViewHeader: FC<TableViewHeaderProps> = ({ title }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('..');
  };
  const { tableView_id } = useParams<{ tableView_id: string }>();

  return (
    <Box
      w="full"
      px="6"
      py="2"
      className="bg-white border-b border-neutral-200"
    >
      <FlexRow alignItems="center" gap="2">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBackClick}
          className="h-6 w-6 shrink-0 rounded"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <Text variant="body" color="primary">
          {title}
        </Text>
        <EditTableViewModal
          tableViewId={tableView_id}
          trigger={
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 shrink-0 rounded"
            >
              <Pencil className="h-3.5 w-3.5" />
            </Button>
          }
        />
      </FlexRow>
    </Box>
  );
};
